import { Route, Routes } from "react-router-dom";
import { memo } from "react";
import HomePage from "../screens/Home/HomePage";
import TextingPanel from "../screens/Profile/CreatorPanels/TextingPanel";
import PayoutsPanel from "../screens/Profile/CreatorPanels/MonetizePanels/PayoutsPanel";
import ProductsPanel from "../screens/Profile/CreatorPanels/MonetizePanels/ProductsPanel";
import HomePanel from "../screens/Profile/CreatorPanels/HomePanel";
import ConversationsPanel from "../screens/Profile/CreatorPanels/ConversationsPanel";
import ContactsPanel from "../screens/Profile/CreatorPanels/AudiencePanels/ContactsPanel";
import ListsPanel from "../screens/Profile/CreatorPanels/AudiencePanels/ListsPanel";
import ImportPanel from "../screens/Profile/CreatorPanels/AudiencePanels/ImportPanel";
import IntegrationsPanel from "../screens/Profile/CreatorPanels/AudiencePanels/IntegrationsPanel";
import ProfilePanel from "../screens/Profile/CreatorPanels/ProfilePanel";
import MembershipsPanel from "../screens/Profile/CreatorPanels/MonetizePanels/MembershipsPanel";
import FinishOnboardingPanel from "../screens/Profile/CreatorPanels/FinishOnboardingPanel";
import VerificationAccountStatusPanel from "../screens/Profile/CreatorPanels/VerificationAccountStatusPanel";
import ReferralProgramPanel from "../screens/Profile/CreatorPanels/ReferralProgramPanel";
import TrackingLinksPanel from "../screens/Profile/CreatorPanels/GrowPanels/TrackingLinksPanel";
import CreatorSettingsPanel from "../screens/Profile/CreatorPanels/CreatorSettingsPanel";
import ProfileSubscribeFormPanel from "../screens/Profile/CreatorPanels/GrowPanels/ProfileSubscribeFormPanel";
import DataQuestionsPanel from "../screens/Profile/CreatorPanels/AudiencePanels/DataQuestionsPanel";
import AutoDMPanel from "../screens/Profile/CreatorPanels/GrowPanels/AutoDMPanel";

const HomeRoute = memo(function HomeRouteFn() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />}>
        <Route index element={<HomePanel />} />
        <Route path="profile" element={<ProfilePanel />} />
        <Route path="contacts" element={<ContactsPanel />} />
        <Route path="data-questions" element={<DataQuestionsPanel />} />
        <Route path="memberships" element={<MembershipsPanel />} />
        <Route path="lists" element={<ListsPanel />} />
        <Route path="import" element={<ImportPanel />} />
        <Route path="integrations" element={<IntegrationsPanel />} />
        <Route path="products" element={<ProductsPanel />} />
        <Route path="tracking-links" element={<TrackingLinksPanel />} />
        <Route path="auto-dm" element={<AutoDMPanel />} />
        <Route path="subscribe-form" element={<ProfileSubscribeFormPanel />} />
        <Route path="texting" element={<TextingPanel />} />
        <Route path="conversations" element={<ConversationsPanel />} />
        <Route path="settings" element={<CreatorSettingsPanel />} />
        <Route path="payouts" element={<PayoutsPanel />} />
        <Route path="finish-onboarding" element={<FinishOnboardingPanel />} />
        <Route
          path="account-status"
          element={<VerificationAccountStatusPanel />}
        />
        <Route path="referral-program" element={<ReferralProgramPanel />} />
      </Route>
    </Routes>
  );
});

export default HomeRoute;
